import type { VaultKind } from '@onefootprint/request-types/dashboard';
import { createContext, useContext } from 'react';

/**
 * The vault the custom data page collects into. Identity (`id.*`) DIs are only writable on a person
 * vault, so the DI picker hides them on a business page.
 */
const SubjectContext = createContext<VaultKind>('person');
export const SubjectProvider = SubjectContext.Provider;
export const useSubject = () => {
  return useContext(SubjectContext);
};